//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.11.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngSelect', srsngSelect);

    function srsngSelect($timeout) {

        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                ngChange: '&',
                inactive: '='
            },
            require: 'ngModel',
            transclude: true,
            templateUrl: 'container/ui/app/widgets/select/select.html',
            controller: controller,
            link: link
        };

        function controller($scope, $element) {

            $scope.options = [];

            this.addOption = option => {

                $scope.options.push(option);
                if (!$scope.listContainerElm) $scope.listContainerElm = option.getElement().closest('.srsng-options');
                if (_.isEqual(option.ngModel, $scope.ngModel)) $scope.getOptionContent(option);
            };

            this.setSelectValue = value => {
                $scope.ngModel = value;
                $scope.listVisible = false;
                $element.controller('ngModel').$setDirty();
                $element.controller('ngModel').$setTouched();
                $timeout(function() {
                    $scope.ngChange();
                });
            };

            $scope.getArrowIconUrl = () => {
                return `container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-${$scope.listVisible ? 'up' : 'down'}-16x16.svg`;
            };
        }

        function link(scope, element, attrs) {
            let selectValueElm = element.find('.srsng-select > .select > .select-content');

            scope.alt = 'altStyle' in attrs;

            scope.$watch('ngModel', newVal => {

                let option = scope.options.find(option => _.isEqual(option.ngModel, newVal));

                if (option) {
                    scope.getOptionContent(option);
                } else {
                    selectValueElm.html('&nbsp;');
                }

            });

            scope.getOptionContent = option => {
                option.getContent(content => selectValueElm.html(content));
            };

            scope.toggleList = () => {

                scope.listVisible = !scope.listVisible;

                if (scope.listVisible) {
                    scope.listContainerElm.width(element.children('.srsng-select').width());
                }
            };
        }
    }
})();